export const NAME = 'name';
export const EMAIL = 'email';
export const ROLE = 'role';
export const LAST_ACTIVE = 'last_active';
